module.exports = __webpack_public_path__ + "static/media/help_graph_1.5bdd9d64.png";